<template>
    <div class="p-3">
        <h3>Pencarian Pasien</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            <!--
            <div class="col-md-6">
                <div class="mb-3 row">
                    <label for="firstname" class="col-sm-3 col-form-label">Nama Pasien</label>
                    <div class="col-sm-9">
                        <input type="text" class="form-control" id="firstname" value="">
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="medrec" class="col-sm-3 col-form-label">No. Rekam Medis</label>
                    <div class="col-sm-9">
                        <input type="text" class="form-control" id="medrec" value="">
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="regno" class="col-sm-3 col-form-label">No. Registrasi</label>
                    <div class="col-sm-9">
                        <input type="text" class="form-control" id="regno" value="">
                    </div>
                </div>
            </div>
            -->
            
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="regno" class="col-sm-4 col-form-label text-end">No. Registrasi</label>
                    <div class="col-sm-8">
                        <input type="text" name="regno" id="regno" class="form-control" v-model="filter.regno">
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="mb-3 row">
                    <label for="medrec" class="col-sm-4 col-form-label text-end">No. Medrec</label>
                    <div class="col-sm-8">
                        <input type="text" name="medrec" id="medrec" class="form-control" v-model="filter.medrec">
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="mb-3 row">
                    <label for="firstname" class="col-sm-4 col-form-label text-end">Nama Pasien</label>
                    <div class="col-sm-8">
                        <input type="text" name="firstname" id="firstname" class="form-control" v-model="filter.firstname">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllPasien"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>
            
        </div>
        <hr/>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Pasien</div>
            <div class="card-body">
                <div id="table-pasien"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default{
    data(){
        return {
            filter: {
                regno: '',
                medrec: '',
                firstname: ''
            },
            data_pasien: []
        }
    },
    created() {
        this.filter.page = this.$route.query.page ?? 1
    },
    mounted(){
        this.getAllPasien()
    },
    methods: {
        getAllPasien(){
            const uri = `/api/cari-pasien/get-all?regno=${this.filter.regno}&medrec=${this.filter.medrec}&firstname=${this.filter.firstname}`
            
            const element = document.getElementById('table-pasien')

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',

                columns: [
                    {title: 'No. RM', field: 'Medrec'},
                    {title: 'Nama Pasien', field: 'Firstname'},
                    {title: 'TTL', field: 'ttl'},
                    {title: 'Jenis Kelamin', field: 'Sex'},
                    {title: 'No. Reg', field: 'Regno'},
                    {title: 'Tanggal Masuk', field: 'Regdate'},
                    {title: 'Pelayanan', field: 'pelayanan'},
                    {title: 'Poli/Bangsal/Kelas', field: 'poli_ruangan'},
                    {title: 'Status'},
                ]
            })
        },
        AjaxResponse(url, params, response) {
            return response.data_pasien
        },
        resetFilters(){
            this.filter = {
                regno: '',
                medrec: '',
                firstname: '',
                page: 1,
            }

            this.getAllPasien()
        }
    }
}
</script>